import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=1c49d0b3&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49d0b3",
  null
  
)

export default component.exports